import React from "react";
import { CallParticipantListParticipant, VideoGalleryRemoteParticipant } from "@azure/communication-react";
import { ContextualMenuItemType, IContextualMenuItem, mergeStyles } from "@fluentui/react";
import { pcpBluePalette, pcpLiveFeatures } from "live-lesson/shared/feature-call-ui-react";
import { ChatFilled, DeleteFilled, HandRightOffFilled, MicFilled, MicOffFilled } from "@fluentui/react-icons";


const iconSize = 18;
const iconColor = pcpBluePalette.foregroundDarkAlternative;


export type CreateMenuItemsCallbacks = {
    muteParticipant: (participantId: string) => void;
    lowerHandAndUnmute: (participantId: string) => void;
    lowerHandWithoutUnmute: (participantId: string) => void;
    removeParticipant: (participantId: string) => void;
    onSendDirectMessage?: (participantId: string) => void;
}

export const createMenuItems = (
    callbacks: CreateMenuItemsCallbacks,
    callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
    myUserId?: string
): IContextualMenuItem[] => {
    const {
        muteParticipant,
        lowerHandAndUnmute,
        lowerHandWithoutUnmute,
        removeParticipant,
        onSendDirectMessage,
    } = callbacks;

    const menuItems: IContextualMenuItem[] = [];

    if (callingParticipant.isMuted === false) {
        menuItems.push(createMuteMenuItem(callingParticipant, muteParticipant));
    }

    if (callingParticipant.raisedHand) {
        menuItems.push(createLowerHandAndUnmuteMenuItem(callingParticipant, lowerHandAndUnmute));
        menuItems.push(createLowerHandWithoutUnmuteMenuItem(callingParticipant, lowerHandWithoutUnmute));
    }

    if (pcpLiveFeatures.privateChats && onSendDirectMessage && callingParticipant.userId !== myUserId) {
        menuItems.push(createSendPrivateMessageMenuItem(callingParticipant, onSendDirectMessage));
    }


    if (callingParticipant.userId !== myUserId) {

        if (menuItems.length > 0) {
            menuItems.push({ key: 'divider_1', itemType: ContextualMenuItemType.Divider, className: mergeStyles({ margin: '5px 0' }) });
        }

        menuItems.push(createRemoveParticipantMenuItem(callingParticipant, removeParticipant));
    }

    return menuItems;

}



export const createMuteMenuItem = (
    callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
    muteParticipant: (participantId: string) => void
): IContextualMenuItem => ({
    key: 'mute',
    title: "Teilnehmer stummschalten",
    text: 'Stummschalten',
    onRenderIcon: () => (<MicOffFilled fontSize={iconSize} color={iconColor} />),
    onClick: () => muteParticipant(callingParticipant.userId),
});

export const createLowerHandAndUnmuteMenuItem = (
    callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
    muteParticipant: (participantId: string) => void
): IContextualMenuItem => ({
    key: 'lowerHandAndUnmute',
    title: "Aufrufen",
    text: 'Aufrufen',
    // iconProps: { iconName: 'ControlButtonMicOn' },
    onRenderIcon: () => (<MicFilled fontSize={iconSize} color={iconColor} />),
    onClick: () => muteParticipant(callingParticipant.userId),
});

export const createLowerHandWithoutUnmuteMenuItem = (
    callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
    onClick: (participantId: string) => void
): IContextualMenuItem => ({
    key: 'lowerHandWithoutUnmute',
    title: "Hand senken",
    text: 'Hand senken',
    // iconProps: { iconName: 'ControlButtonLowerHand' },
    onRenderIcon: () => (<HandRightOffFilled  fontSize={iconSize} color={iconColor} />),
    onClick: () => onClick(callingParticipant.userId),
});

export const createSendPrivateMessageMenuItem = (
    callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
    onClick: (participantId: string) => void
): IContextualMenuItem => ({
    key: 'sendPrivateMessage',
    title: "Privatnachricht senden",
    text: 'Privatnachricht senden',
    onRenderIcon: () => (<ChatFilled  fontSize={iconSize} color={iconColor} />),
    onClick: () => onClick(callingParticipant.userId),
});

export const createRemoveParticipantMenuItem = (
    callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
    onClick: (participantId: string) => void
): IContextualMenuItem => ({
    key: 'removeParticipant',
    title: "Schüler entfernen",
    text: 'Schüler entfernen',
    iconProps: { iconName: 'Trash' },
    onRenderIcon: () => (<DeleteFilled  fontSize={iconSize} color={iconColor} />),
    styles: { color: 'red' },
    className: mergeStyles({
        color: 'red',
        '*': {
            color: 'red !important',
        }
    }),
    onClick: () => onClick(callingParticipant.userId),
});



// TODO: following functions are not used in the codebase, should be removed. Keeping for now for reference.
// export const createMuteMenuItem = (
//     callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
//     muteParticipant: (participantId: string) => void,
//     unmuteParticipant: (participantId: string) => void
// ): IContextualMenuItem => ({
//     key: 'mute',
//     title: "Teilnehmer stummschalten",
//     text: callingParticipant.isMuted ? 'Wort erteilen' : 'Stummschalten',
//     iconProps: callingParticipant.isMuted ? { iconName: 'ControlButtonMicOn' } : { iconName: 'ControlButtonMicOff' },
//     onClick: () => callingParticipant.isMuted
//         ? unmuteParticipant(callingParticipant.userId)
//         : muteParticipant(callingParticipant.userId),
// });

// export const createLowerHandMenuItem = (
//     callingParticipant: CallParticipantListParticipant|VideoGalleryRemoteParticipant,
//     lowerHand: (participantId: string) => void
// ): IContextualMenuItem => ({
//     key: 'lowerHand',
//     title: "Hand senken",
//     text: 'Hand senken',
//     iconProps: { iconName: 'HandLower' },
//     onClick: () => lowerHand(callingParticipant.userId),
// });
